import { Actions, ActionTypes } from '@appStore/products/actions';

export interface State{
    productAgreementCreated: boolean;
    createProductAgreementLoading: boolean;
    createProductAgreementLoaded: boolean;
    createProductAgreementId: number;
    activeAgreementLink: string;
    activeAgreementLinkLoading: boolean;
    activeAgreementLinkLoaded: boolean;
}

export const initialState: State ={
    productAgreementCreated: false,
    createProductAgreementLoading: false,
    createProductAgreementLoaded: false,
    createProductAgreementId: null,
    activeAgreementLink: null,
    activeAgreementLinkLoading: false,
    activeAgreementLinkLoaded: false
}

export function reducer(state = initialState, action: Actions): State {
    switch(action.type){
        case ActionTypes.CreateProductAgreement:
            return {...state, productAgreementCreated: false, createProductAgreementLoading: true, createProductAgreementLoaded: false, createProductAgreementId: null };
        case ActionTypes.CreateProductAgreementSuccess:
            return {...state, productAgreementCreated: true, createProductAgreementLoading: false, createProductAgreementLoaded: true, createProductAgreementId: action.payload };
        case ActionTypes.CreateProductAgreementFail:
            return {...state, productAgreementCreated: false, createProductAgreementLoading: false, createProductAgreementLoaded: false, createProductAgreementId: null };
        case ActionTypes.AgreementLinkLoad:
            return {...state, activeAgreementLink: null, activeAgreementLinkLoaded: false, activeAgreementLinkLoading: true };
        case ActionTypes.AgreementLinkLoadSuccess:
            return {...state, activeAgreementLink: action.payload, activeAgreementLinkLoaded: true, activeAgreementLinkLoading: false };
        case ActionTypes.AgreementLinkLoadFail:
            return {...state, activeAgreementLink: null, activeAgreementLinkLoaded: false, activeAgreementLinkLoading: false };
    }
    
    return state;
}

export const getProductAgreementCreated = (state: State) => state.productAgreementCreated;
export const getProductAgreementCreateId = (state: State) => state.createProductAgreementId;
export const getActiveAgreementLink = (state: State) => state.activeAgreementLink;
export const getActiveAgreementLinkLoaded = (state: State) => state.activeAgreementLinkLoaded;